import { useEffect, useState } from 'react';
import { useIsRTL } from '../../locale';
export function useSliderDrag(props) {
  const [isDragging, setIsDragging] = useState(false);
  const [didDrag, setDidDrag] = useState(false);
  const [[startClientX, startClientY], setDragStartClientPos] = useState([NaN, NaN]);
  const [lastDragStartPos, setLastDragStartPos] = useState(NaN);
  const isRTL = useIsRTL();
  useEffect(() => {
    if (!isDragging) return;
    function dragPos(clientX, clientY) {
      const boundsSize = props.clientBounds.getSize();
      if (!boundsSize) return undefined;
      let pos = 0;
      if (props.orientation === 'vertical') {
        pos = (clientY - startClientY) / boundsSize.height;
        pos *= -1;
      } else {
        pos = (clientX - startClientX) / boundsSize.width;
        if (isRTL) {
          pos *= -1;
        }
      }
      pos += lastDragStartPos;
      if (pos < props.minPosition) {
        pos = props.minPosition;
      } else if (pos > props.maxPosition) {
        pos = props.maxPosition;
      }
      return pos;
    }
    function onDrag(e) {
      if (!props.onChange) return;
      const position = dragPos(e.clientX, e.clientY);
      let gripDidDrag = false;
      if (position !== lastDragStartPos) {
        gripDidDrag = true;
        setDidDrag(true);
      }
      if (position !== undefined) {
        props.onChange.call(undefined, {
          position,
          didDrag: gripDidDrag
        });
      }
    }
    function onDragEnd(e) {
      // only respond to left buttons being lifted
      if (e.button !== 0) return;
      setIsDragging(false);
      const position = dragPos(e.clientX, e.clientY);
      let gripDidDrag = false;
      if (position !== lastDragStartPos) {
        gripDidDrag = true;
        setDidDrag(true);
      }
      if (position !== undefined) {
        if (props.onChange) props.onChange.call(undefined, {
          position,
          didDrag: gripDidDrag
        });
        if (props.onCommit) props.onCommit.call(undefined, {
          position,
          didDrag: gripDidDrag
        });
      }
    }
    window.addEventListener('mousemove', onDrag);
    window.addEventListener('mouseup', onDragEnd);
    return () => {
      window.removeEventListener('mousemove', onDrag);
      window.removeEventListener('mouseup', onDragEnd);
    };
  });
  return {
    startDrag(dragStartClientPos, dragStartPos) {
      setDragStartClientPos(dragStartClientPos);
      setLastDragStartPos(dragStartPos);
      setDidDrag(false);
      setIsDragging(true);
    },
    abortDrag() {
      setIsDragging(false);
    },
    lastDragStartPos,
    didDrag
  };
}
//# sourceMappingURL=useSliderDrag.js.map